import styled from "styled-components";

export const MainDiv = styled.div`
  padding: 30px 16px 16px;
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
`;
export const SectionTitle = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const SectionText = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const ClinicalDataDiv = styled.div`
  margin-top: 49px;
  padding: 16px;
  width: 100%;
  border-radius: 2px;
  background: rgba(242, 242, 242, 0.95);
`;
export const LegendsDiv = styled.div`
  margin-bottom: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const LegendDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const LegendColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100px;
  background: ${({ background }) => background && background};
`;
export const StatusDiv = styled.div`
  margin: ${({ margin }) => margin && margin};
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ background }) => background && background};
  gap: 4px;
`;
export const StatusText = styled.p`
  color: #fff;
  font-size: 10px;
  font-weight: 600;
`;
export const StatusImg = styled.img`
  width: 12px;
  height: 12px;
`;
export const MainPlotDiv = styled.div`
  padding: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionsDiv = styled.div`
  margin-top: 50px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  gap: 4px;
`;
export const ActionImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const ActionTitle = styled.p`
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
`;
